<div
  class="d-flex flex-row justify-content-center"
  style="flex-wrap: nowrap"
>
  <!-- <button type="button" class="pass-btn"  (click)="scrollLeft()"><<</button> -->
  <ul
    id="list-items"
    class="scroll-container"
    style="margin-bottom: 0; height: 48px; overflow-y: hidden"
    #scrollContainer
  >
    <li>
      <div style="width: max-content; padding-bottom: 1px;">
        <a
          (click)="caltalogFnc()"
          routerLink="/catalogo"
          data-ma-action="submenu-toggle"
          class="catalog-line-item"
          i18n
          style="
            color: white;
            font-size: 12px;
            white-space: nowrap;
            text-align: center;
          "
          >TODOS OS PRODUTOS
        </a>
      </div>
    </li>
    <li
      class="horizontal-li"
      *ngFor="let item of menu"
      style="text-decoration: dotted;"
    >
      <!-- <div class="menu-filtro panel-heading-container" style="width: max-content"
        (mouseenter)="item.selected = mouseEnterEvent(item)" (mouseleave)="item.selected = false"
        (click)="item.selected = false"> -->
      <div
        class="menu-filtro panel-heading-container"
        style="width: max-content"
        (mouseenter)="item.selected = mouseEnterEventHover(item)"
        (mouseleave)="item.selected = false"
        (click)="item.selected = mouseEnterEvent(item)"
        *ngIf="!mobileLg"
      >
        <div
          class="panel-heading-container"
          *ngIf="item.children.length; else elseBlockNotHasChildren"
        >
          <!-- <button
            data-toggle="collapse"
            style="padding-top: 0; padding-bottom: 0; font-size: 12px"
            type="button"
            class="panel-heading {{
              !item.selected ? 'btn-panel' : 'collapsed'
            }}"
            (click)="onClick(item.description, item.children, item)"
          >
            {{ item.description }}
          </button> -->
          <button
            data-toggle="collapse"
            style="padding: 0; font-size: 12px"
            type="button"
            class="btn-panel"
            (click)="onClick(item.description, item.children, item)"
          >
            <!-- <button data-toggle="collapse" style="padding-top: 0; padding-bottom: 0; font-size: 12px" type="button"
            class="btn-panel"> -->
            {{ item.description }}
          </button>

          <div
            id="box{{ currentItem.id }}"
            style="
              background-color: #fff;
              border-radius: 0%;
              display: flex;
              flex-direction: row;
              z-index: 99999;
              padding: 0px 5% 0px 5%;
              position: absolute;
              min-height: 350px;
              box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,
                rgba(0, 0, 0, 0.23) 0px 3px 6px;
            "
            [style.left]="layoutMenu === 3 ? '0' : '0%'"
            [style.width]="layoutMenu === 3 ? '100%' : '100%'"
            [style.max-height]="layoutMenu === 3 ? '350px' : '520px'"
            class="list-group list-group-flush panel-collapse collapse {{
              currentItem.selected && item.selected ? 'show' : 'hide'
            }}"
          >
            <ul
              style="
                margin-left: auto;
                background-color: #fff;
                min-height: 350px;
                overflow: hidden;
              "
              [style.max-height]="layoutMenu === 3 ? '350px' : '520px'"
              [class]="layoutMenu === 3 ? 'list-dropdown-col' : 'list-dropdown'"
            >
              <li
                *ngFor="let subItem of currentItem.children"
                [style]="layoutMenu === 3 ? 'padding: 0; height: 20px' : ''"
              >
                <app-treeview-link-horizontal
                  #submenu
                  *ngIf="layoutMenu === 1"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal>
                <app-treeview-link-horizontal-opt2
                  #submenu
                  *ngIf="layoutMenu === 2"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal-opt2>
                <app-treeview-link-horizontal-opt3
                  #submenu
                  *ngIf="layoutMenu === 3"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal-opt3>
              </li>
            </ul>
            <div class="wrapper-img" *ngIf="layoutMenu === 3 && item.Imagems">
              <div
                *ngIf="item.Imagems.length > 0"
                class="img-1"
                (click)="imgSelect(item.Imagems[0].link)"
              >
                <img
                  width="301"
                  height="301"
                  style="margin-top: 0%; cursor: pointer; width: 301px"
                  class="img-1-inside"
                  src="{{ API_IMAGENS }}{{ item.Imagems[0].imagem }}"
                />
              </div>
              <div
                style="margin-top: 0%; width: 301px"
                class="row row-cols-1 container-banner"
              >
                <div
                  (click)="imgSelect(item.Imagems[1].link)"
                  class="d-flex flex-row img-1-outside align-items-center"
                  *ngIf="item.Imagems.length > 1"
                >
                  <img
                    width="301"
                    height="146"
                    class="col img-2 img-2-inside"
                    style="cursor: pointer; width: 301px"
                    src="{{ API_IMAGENS }}{{ item.Imagems[1].imagem }}"
                  />
                </div>
                <div
                  class="d-flex flex-row img-2-outside align-items-start"
                  *ngIf="item.Imagems.length > 2"
                  (click)="imgSelect(item.Imagems[2].link)"
                >
                  <img
                    width="301"
                    height="146"
                    class="col img-2 img-3-inside"
                    style="cursor: pointer; width: 301px"
                    src="{{ API_IMAGENS }}{{ item.Imagems[2].imagem }}"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div
        id="box{{ item.id }}"
        class="dropdown-box list-group list-group-flush panel-collapse collapse {{
          item.selected ? 'show' : ''
        }}"
        >
          <app-treeview-link
          #submenu
          (onSelect)="onSelect($event)"
          *ngFor="let subItem of item.children"
          [item]="subItem"
          [selected]="subItem.selected"
          [parent]="item.description"
          (breadCrumb)="saveBc($event)"
          ></app-treeview-link>
        </div> -->
        </div>
        <hr />
        <ng-template #elseBlockNotHasChildren>
          <button
            data-toggle="collapse"
            style="padding-top: 0"
            type="button"
            class="btn-panel"
            (click)="selectRoot(item.id, item.description)"
          >
            {{ item.description }}
          </button>
        </ng-template>
      </div>
      <!-- <div
          id="box{{ currentItem.id }}"
          class="list-group list-group-flush panel-collapse collapse {{
            currentItem.selected ? 'show' : ''
          }}"
          >
          <app-treeview-link-horizontal
          #submenu
          (onSelect)="onSelect($event)"
          *ngFor="let subItem of currentItem.children"
          [item]="subItem"
          [selected]="subItem.selected"
          [parent]="currentItem.description"
          (breadCrumb)="saveBc($event)"
          ></app-treeview-link-horizontal>
        </div> -->
        <div
        *ngIf="mobileLg"
        class="menu-filtro panel-heading-container"
        style="width: max-content"
        (mouseenter)="item.selected = mouseEnterEventHover(item)"
        (mouseleave)="item.selected = false"
        (click)="item.selected = mouseEnterEvent(item)"
      >
        <div
          class="panel-heading-container"
          *ngIf="item.children.length; else elseBlockNotHasChildren"
        >
          <!-- <button
            data-toggle="collapse"
            style="padding-top: 0; padding-bottom: 0; font-size: 12px"
            type="button"
            class="panel-heading {{
              !item.selected ? 'btn-panel' : 'collapsed'
            }}"
            (click)="onClick(item.description, item.children, item)"
          >
            {{ item.description }}
          </button> -->
          <!-- <button
            data-toggle="collapse"
            style="padding-top: 0; padding-bottom: 0; font-size: 12px"
            type="button"
            class="btn-panel"
            (click)="onClick(item.description, item.children, item)"
          > -->
            <button data-toggle="collapse" style="padding-top: 0; padding-bottom: 0; font-size: 12px" type="button"
            class="btn-panel">
            {{ item.description }}
          </button>

          <div
            id="box{{ currentItem.id }}"
            style="
              background-color: #fff;
              border-radius: 0%;
              display: flex;
              flex-direction: row;
              z-index: 99999;
              padding: 0px 5% 0px 5%;
              position: absolute;
              min-height: 350px;
              box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,
                rgba(0, 0, 0, 0.23) 0px 3px 6px;
            "
            [style.left]="layoutMenu === 3 ? '0' : '0%'"
            [style.width]="layoutMenu === 3 ? '100%' : '100%'"
            [style.max-height]="layoutMenu === 3 ? '350px' : '520px'"
            class="list-group list-group-flush panel-collapse collapse {{
              currentItem.selected && item.selected ? 'show' : 'hide'
            }}"
          >
            <ul
              style="
                margin-left: auto;
                background-color: #fff;
                min-height: 350px;
                overflow: hidden;
              "
              [style.max-height]="layoutMenu === 3 ? '350px' : '520px'"
              [class]="layoutMenu === 3 ? 'list-dropdown-col' : 'list-dropdown'"
            >
              <li
                *ngFor="let subItem of currentItem.children"
                [style]="layoutMenu === 3 ? 'padding: 0; height: 20px' : ''"
              >
                <app-treeview-link-horizontal
                  #submenu
                  *ngIf="layoutMenu === 1"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal>
                <app-treeview-link-horizontal-opt2
                  #submenu
                  *ngIf="layoutMenu === 2"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal-opt2>
                <app-treeview-link-horizontal-opt3
                  #submenu
                  *ngIf="layoutMenu === 3"
                  (onSelect)="onSelect($event)"
                  [item]="subItem"
                  [selected]="subItem.selected"
                  [parent]="currentItem.description"
                  (breadCrumb)="saveBc($event)"
                ></app-treeview-link-horizontal-opt3>
              </li>
            </ul>
            <div class="wrapper-img" *ngIf="layoutMenu === 3 && item.Imagems">
              <div
                *ngIf="item.Imagems.length > 0"
                class="img-1"
                (click)="imgSelect(item.Imagems[0].link)"
              >
                <img
                  width="301"
                  height="301"
                  style="margin-top: 0%; cursor: pointer; width: 301px"
                  class="img-1-inside"
                  src="{{ API_IMAGENS }}{{ item.Imagems[0].imagem }}"
                />
              </div>
              <div
                style="margin-top: 0%; width: 301px"
                class="row row-cols-1 container-banner"
              >
                <div
                  (click)="imgSelect(item.Imagems[1].link)"
                  class="d-flex flex-row img-1-outside align-items-center"
                  *ngIf="item.Imagems.length > 1"
                >
                  <img
                    width="301"
                    height="146"
                    class="col img-2 img-2-inside"
                    style="cursor: pointer; width: 301px"
                    src="{{ API_IMAGENS }}{{ item.Imagems[1].imagem }}"
                  />
                </div>
                <div
                  class="d-flex flex-row img-2-outside align-items-start"
                  *ngIf="item.Imagems.length > 2"
                  (click)="imgSelect(item.Imagems[2].link)"
                >
                  <img
                    width="301"
                    height="146"
                    class="col img-2 img-3-inside"
                    style="cursor: pointer; width: 301px"
                    src="{{ API_IMAGENS }}{{ item.Imagems[2].imagem }}"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div
        id="box{{ item.id }}"
        class="dropdown-box list-group list-group-flush panel-collapse collapse {{
          item.selected ? 'show' : ''
        }}"
        >
          <app-treeview-link
          #submenu
          (onSelect)="onSelect($event)"
          *ngFor="let subItem of item.children"
          [item]="subItem"
          [selected]="subItem.selected"
          [parent]="item.description"
          (breadCrumb)="saveBc($event)"
          ></app-treeview-link>
        </div> -->
        </div>
        <hr />
        <ng-template #elseBlockNotHasChildren>
          <button
            data-toggle="collapse"
            style="padding-top: 0"
            type="button"
            class="btn-panel"
            (click)="selectRoot(item.id, item.description)"
          >
            {{ item.description }}
          </button>
        </ng-template>
      </div>
    </li>
  </ul>
  <!-- <button type="button" class="pass-btn"  (click)="scrollRight()">>></button> -->
</div>
